import { useMemo, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'

import { PktButton,PktCheckbox, PktInputWrapper } from '..'

type FormData = {
  values: string[]
}

export default function Checkbox() {
  const checkboxRef = useRef<HTMLInputElement | null>(null)
  const [isIndeterminate, setIsIndeterminate] = useState(false)
  const [isChecked, setIsChecked] = useState(false)

  const handleCheckboxChange = (id: string, label: string, checked: boolean) => {
    console.log(`Checkbox with id ${id} and label "${label}" checked:`, checked)
  }

  const checkForm = [
    {
      id: 'checkboxForm',
      label: 'Checkbox med inputwrapper',
    },
    {
      id: 'checkboxForm2',
      label: 'Checkbox med inputwrapper',
    },
    {
      id: 'checkboxForm3',
      label: 'Checkbox med inputwrapper',
    },
  ]

  const { handleSubmit, register, getValues } = useForm<FormData>({
    defaultValues: {
      values: ['value1', 'value2'],
    },
  })

  const MOCK_SUBMIT = useMemo(() => {
    return () => {
      const values = getValues()
      alert('Submitting ' + JSON.stringify(values))
    }
  }, [getValues])

  return (
    <>
      <main className="page-main pkt-container">
        <h1>Checkbox</h1>

        <section className="component">
          <PktCheckbox
            id="checboxSingle"
            label="Checkbox"
            onChange={(e) => handleCheckboxChange('checboxSingle', 'Checkbox', e.target.checked)}
          />
        </section>

        <section className="component">
          <h2>Indeterminate state</h2>
          <p>Checkbox med indeterminate state. Bruk knappene for å endre tilstand.</p>
          <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
            <PktCheckbox
              id="indeterminateCheckbox"
              label="Indeterminate checkbox"
              checked={isChecked}
              indeterminate={isIndeterminate}
              onChange={(e) => {
                setIsChecked(e.target.checked)
                setIsIndeterminate(false)
                handleCheckboxChange('indeterminateCheckbox', 'Indeterminate checkbox', e.target.checked)
              }}
            />
            <PktButton
              onClick={() => {
                setIsIndeterminate(!isIndeterminate)
                setIsChecked(false)
              }}
            >
              Indeterminate
            </PktButton>
            <PktButton
              onClick={() => {
                setIsIndeterminate(false)
                setIsChecked(true)
              }}
            >
              Check
            </PktButton>
            <PktButton
              onClick={() => {
                setIsIndeterminate(false)
                setIsChecked(false)
              }}
            >
              Uncheck
            </PktButton>
          </div>
        </section>

        <section className="component">
          <PktCheckbox
            id="checkboxHelptext"
            label="Checkbox med hjelpetekst"
            checkHelptext={
              <>
                Denne valgfrie teksten kan <strong>brukes</strong> til å beskrive etiketten mer detaljert.
              </>
            }
            onChange={(e) => handleCheckboxChange('checkboxHelptext', 'Checkbox med hjelpetekst', e.target.checked)}
          />
        </section>

        <section className="component">
          <PktCheckbox
            id="checkboxWithDefaultChecked"
            label="Checkbox med default checked og disabled"
            disabled
            defaultChecked
            onChange={(e) =>
              handleCheckboxChange('checkboxGroupInputwrapper', 'Checkbox med inputwrapper', e.target.checked)
            }
          />
          <PktCheckbox
            id="checkboxWithDefaultChecked2"
            label="Checkbox med tile, default checked og disabled"
            disabled
            hasTile
            defaultChecked
            onChange={(e) =>
              handleCheckboxChange(
                'checkboxGroupInputwrapper2',
                'Checkbox med inputwrapper tile disabled',
                e.target.checked,
              )
            }
          />
        </section>

        <section className="component">
          <h2>Med inputwrapper</h2>
          <PktInputWrapper
            label="Etikett"
            helptext="Dette er tekst over avmerkingsboksene."
            optionalTag
            optionalText="Valgfritt"
            forId="checkboxGroup3"
            hasFieldset
          >
            <PktCheckbox
              key="checkboxGroupInputwrapper"
              id="checkboxGroupInputwrapper"
              label="Checkbox med inputwrapper"
              checkHelptext="Denne valgfrie teksten kan brukes til å beskrive etiketten mer
                            detaljert."
              onChange={(e) =>
                handleCheckboxChange('checkboxGroupInputwrapper', 'Checkbox med inputwrapper', e.target.checked)
              }
            />
            <PktCheckbox
              key="checkboxGroupInputwrapper2"
              id="checkboxGroupInputwrapper2"
              label="Checkbox med inputwrapper"
              checked
              tagText={'Taggtekst'}
              optionalTag
              requiredTag
              onChange={(e) =>
                handleCheckboxChange('checkboxGroupInputwrapper2', 'Checkbox med inputwrapper', e.target.checked)
              }
            />
            <PktCheckbox
              key="checkboxGroupInputwrapper3"
              id="checkboxGroupInputwrapper3"
              label="Checkbox med inputwrapper"
              onChange={(e) =>
                handleCheckboxChange('checkboxGroupInputwrapper3', 'Checkbox med inputwrapper', e.target.checked)
              }
            />
          </PktInputWrapper>
        </section>

        <section className="component">
          <h2>Med inputwrapper</h2>
          <PktInputWrapper
            label="Etikett"
            helptext="Dette er tekst over checkboxene"
            helptextDropdown="Bruk dette tekstfeltet til å skrive mer informasjon om inputfeltet."
            helptextDropdownButton="Les mer"
            optionalTag
            optionalText="Valgfritt"
            forId="checkboxGroup3"
            hasFieldset
            hasError
            errorMessage="Dette er en feilmelding"
          >
            <PktCheckbox
              key="checkboxError"
              id="checkboxError"
              label="Checkbox med error"
              checkHelptext="Denne valgfrie teksten kan brukes til å beskrive etiketten mer
                            detaljert."
              onChange={(e) => handleCheckboxChange('checkboxError', 'Checkbox med error', e.target.checked)}
              hasTile
              hasError
            />
            <PktCheckbox
              key="checkboxError2"
              id="checkboxError2"
              label="Checkbox med inputwrapper"
              onChange={(e) => handleCheckboxChange('checkboxError2', 'Checkbox med error', e.target.checked)}
              hasTile
              hasError
            />
            <PktCheckbox
              key="checkboxError3"
              id="checkboxError3"
              label="Checkbox med error"
              onChange={(e) => handleCheckboxChange('checkboxError3', 'Checkbox med error', e.target.checked)}
              hasTile
              hasError
            />
          </PktInputWrapper>
        </section>
        <section className="component">
          <h2>Test av reell skjemaintegrasjon</h2>
          <form onSubmit={handleSubmit(MOCK_SUBMIT)}>
            <PktInputWrapper
              label="Etikett"
              helptext="Dette er tekst over checkboxene"
              helptextDropdown="Bruk dette tekstfeltet til å skrive mer informasjon om inputfeltet."
              helptextDropdownButton="Les mer"
              optionalTag
              optionalText="Valgfritt"
              forId="checkboxGroup3"
              hasFieldset
              hasError
              errorMessage="Dette er en feilmelding"
            >
              {checkForm.map((check, index) => (
                <PktCheckbox
                  key={check.id}
                  id={check.id}
                  label={check.label}
                  value={'value' + index}
                  checkHelptext="Denne valgfrie teksten kan brukes til å beskrive etiketten mer detaljert."
                  hasTile
                  defaultChecked={getValues('values').includes(`value${index}`)}
                  {...register('values')}
                />
              ))}
            </PktInputWrapper>
            <br />
            <PktButton type="submit">Submit</PktButton>
          </form>
        </section>
      </main>
    </>
  )
}
